import React from "react";
import MaterialCheckBox from "../Components/Common/MaterialCheckBox";

export default function HfJobThree({ setValue, mockData }) {
  return (
    <div>
      <div className="shadow-bulk__container">
        <span className="pms-ws_subTitle hf">
          Clear Old Appointment Block Data
        </span>
        <span className="pms-ws_description hf">
        Job runs on a specified schedule to  remove old data in the VwAppointmentBlock tables in the shadow databases. Old data is defined as have an appointment block date older than two weeks ago.
        </span>

        <MaterialCheckBox
          onChange={(e) => setValue(e, true)}
          value={mockData.Job03EnableExecution || false}
          name="Job03EnableExecution"
          label="Enable execution?"
        />
      </div>
    </div>
  );
}
